import createAPIServices from './createAPIServices'
import { baseUrlPhotoCloud } from './createAPIServices'

const userStatusType = {
    ACTIVE: 1,
    BANNED: 2,
    DELETED: 3,
}

const api = createAPIServices()

// api user
export const getUserByArray = uids => {
    return api.makeAuthRequest({
        url: `/users/query/list?uids=${uids}`,
        method: 'GET',
    })
}

export const getListUserNotCheck = (
    page_number = 1,
    page_size = 10,
    status = 0,
    textSearch = ''
) => {
    if (textSearch === '')
        return api.makeAuthRequest({
            url: `/users/pages/notcheck?page_number=${page_number}&page_size=${page_size}&status=${status}`,
            method: 'GET',
        })

    return api.makeAuthRequest({
        url: `/search/users?page_number=${page_number}&page_size=${page_size}&status=${status}&text=${textSearch}`,
        method: 'GET',
    })

}

export const getListUsers = (
    page_number = 1,
    page_size = 10,
    status = 0,
    textSearch = ''
) => {
    if (textSearch === '')
        return api.makeAuthRequest({
            url: `/users/pages?page_number=${page_number}&page_size=${page_size}&status=${status}`,
            method: 'GET',
        })

    return api.makeAuthRequest({
        url: `/search/users?page_number=${page_number}&page_size=${page_size}&status=${status}&text=${textSearch}`,
        method: 'GET',
    })
}
export const createNewUser = user => {
    const json = JSON.stringify(user)

    return api.makeAuthRequest({
        url: `/users/create`,
        method: 'POST',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const getUserById = uid => {
    return api.makeAuthRequest({
        url: `/users/query?uid=${uid}`,
        method: 'GET',
    })
}
export const updateUserById = (uid, user) => {
    const json = JSON.stringify(user)

    return api.makeAuthRequest({
        url: `/users/${uid}`,
        method: 'PUT',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const deleteUserById = uid => {
    return api.makeAuthRequest({
        url: `/users/updatestatus?uid=${uid}&status=${userStatusType.DELETED}`,
        method: 'PUT',
    })
}

export const banUserById = uid => {
    return api.makeAuthRequest({
        url: `/users/updatestatus?uid=${uid}&status=${userStatusType.BANNED}`,
        method: 'PUT',
    })
}

export const uploadAvatar = image => {
    const formData = new FormData()
    formData.append('files', image)

    console.log("Image : ", image)

    const uploadAPI = createAPIServices({
        BaseURL: baseUrlPhotoCloud,
    })

    return uploadAPI.makeRequest({
        method: 'POST',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const checkUsername = username => {
    return api.makeAuthRequest({
        url: `check/username?username=${username}`,
        method: 'GET',
    })
}

export const resetPassword = (username, new_password) => {
    return api.makeAuthRequest({
        url: 'users/resetpass',
        method: 'POST',
        data: {
            password_new: new_password,
            uname: username,
        },
    })
}
